import styles from './VisaAndTravel.module.scss';
import SherpaTripElement from 'src/components/SherpaTripElement/SherpaTripElement';

const VisaAndTravel = () => {
  return (
    <div className={styles['visa-and-travel-container']}>
      <div className="flex flex-col gap-3">
        <h2>Upcoming Travel Plans</h2>
        <p>Check any travel or visa requirements with the widget below.</p>
      </div>

      <div className={styles['travel-disclaimer']}>
        <label>Disclaimer</label>
        <p>
          This information is for general purposes only and does not constitute legal advice or guarantee entry into any
          country. Please consult the official government or embassy website of your destination country for the most
          current and accurate information. If traveling for work-related purposes, please also consult your company’s
          immigration team prior to travel to ensure you are complying with internal policies related to permissible
          activities, duration of stay, and frequency of visit.
        </p>
      </div>

      <SherpaTripElement />
    </div>
  );
};

export default VisaAndTravel;
